import { FloatingMarkerPosition, NavigationApp } from '../types/map';
const getMapProjection = async (map) => {
    const mapProjection = map.getProjection();
    if (!mapProjection) {
        return new Promise(resolve => {
            google.maps.event.addListenerOnce(map, 'projection_changed', () => {
                resolve(map.getProjection());
            });
        });
    }
    return Promise.resolve(mapProjection);
};
export const offsetLatLng = async (map, latLng, offsetX = 0, offsetY = 0) => {
    const scale = 2 ** (map.getZoom() || 1);
    const mapProjection = await getMapProjection(map);
    const pixelOffset = new google.maps.Point(offsetX / scale, offsetY / scale);
    const worldCoordinateCenter = mapProjection.fromLatLngToPoint(new google.maps.LatLng(latLng));
    const worldCoordinateNewCenter = new google.maps.Point(worldCoordinateCenter.x - pixelOffset.x, worldCoordinateCenter.y + pixelOffset.y);
    return mapProjection.fromPointToLatLng(worldCoordinateNewCenter).toJSON();
};
export const toRadians = (num) => {
    return (num * Math.PI) / 180;
};
export const toDegrees = (num) => {
    return (num * 180) / Math.PI;
};
const navigationLinks = {
    [NavigationApp.GoogleMaps]: (latitude, longitude) => `https://www.google.com/maps/dir//${latitude},${longitude}`,
    [NavigationApp.Waze]: (latitude, longitude) => `https://www.waze.com/ul?ll=${latitude}%2C${longitude}&navigate=yes`,
    [NavigationApp.AppleMaps]: (latitude, longitude) => `http://maps.apple.com/?daddr=${latitude},${longitude}`,
};
export const getNavigationLink = (app, latitude, longitude) => {
    return navigationLinks[app](latitude, longitude);
};
export const rhumbBearingByPoints = (startCoordinate, endCoordinate) => {
    const startLatRad = toRadians(startCoordinate.lat);
    const endLatRad = toRadians(endCoordinate.lat);
    let lngDiffRad = toRadians(endCoordinate.lng - startCoordinate.lng);
    if (Math.abs(lngDiffRad) > Math.PI) {
        lngDiffRad = lngDiffRad > 0 ? -(2 * Math.PI - lngDiffRad) : 2 * Math.PI + lngDiffRad;
    }
    const projectedLatDiffRad = Math.log(Math.tan(endLatRad / 2 + Math.PI / 4) / Math.tan(startLatRad / 2 + Math.PI / 4));
    return toDegrees(Math.atan2(lngDiffRad, projectedLatDiffRad));
};
const floatingMarkerStyles = {
    [FloatingMarkerPosition.Top]: (widthStep, heightStep, bearing, sideContentWidth, topAngle, visualSideContentWidth, visualSideContentHeight, sideContentHeight) => {
        const leftPosition = widthStep * (topAngle / 2 + bearing) + visualSideContentWidth;
        return {
            top: `${leftPosition < sideContentWidth ? sideContentHeight : 0}px`,
            right: 'auto',
            bottom: 'auto',
            left: `${leftPosition}px`,
            transform: 'translate3d(-50%, -50%, 0)',
        };
    },
    [FloatingMarkerPosition.Right]: (widthStep, heightStep, bearing, sideContentWidth, topAngle) => {
        return {
            top: `${heightStep * (bearing - topAngle / 2)}px`,
            right: 0,
            bottom: 'auto',
            left: 'auto',
            transform: 'translate3d(50%, -50%, 0)',
        };
    },
    [FloatingMarkerPosition.Left]: (widthStep, heightStep, bearing, sideContentWidth, topAngle, visualSideContentWidth, visualSideContentHeight) => {
        const topPosition = heightStep * Math.abs(bearing + topAngle / 2);
        return {
            top: `${topPosition + visualSideContentHeight}px`,
            right: 'auto',
            bottom: 'auto',
            left: `${visualSideContentWidth}px`,
            transform: 'translate3d(-50%, -50%, 0)',
        };
    },
    [FloatingMarkerPosition.Bottom]: (widthStep, heightStep, bearing, sideContentWidth, topAngle, visualSideContentWidth) => {
        return {
            top: 'auto',
            right: 'auto',
            bottom: 0,
            left: `${widthStep *
                (bearing > 0 ? topAngle - (bearing - (180 - topAngle / 2)) : Math.abs(bearing + (180 - topAngle / 2))) +
                visualSideContentWidth}px`,
            transform: 'translate3d(-50%, 50%, 0)',
        };
    },
};
export const getFloatingMarkerStyle = (position, widthStep, heightStep, bearing, sideContentWidth, topAngle, visualSideContentWidth, visualSideContentHeight, sideContentHeight) => {
    return floatingMarkerStyles[position](widthStep, heightStep, bearing, sideContentWidth, topAngle, visualSideContentWidth, visualSideContentHeight, sideContentHeight);
};
